import React from "react"
import propTypes from "prop-types"
import Loader from "react-loader-spinner"
import { connect } from "react-redux"
import { getActivities, getParticipants } from "../../../../services/guardians"
import "./styles.scss"
import configs from "../../../../configs"

import Header from "../../../../components/Header"
import Notifications from "../../../../components/Notifications"
import Footer from "../../../../components/Footer"
import Messages from "../../components/Messages"

import iconClipboardList from "./images/icon-clipboard-list.svg"
import iconHappy from "./images/icon-happy.svg"
import iconStar from "./images/icon-star.svg"
import iconUserCircle from "./images/icon-user-circle.svg"
import iconUserFriends from "./images/icon-user-friends.svg"

class Activity extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showOnlyIsHidden: true,
      showOnlyCurrent: [],
      showOnlyList: [
        {
          id: 0,
          label: "Support Team Activities",
          name: "supportTeamActivities",
          value: "G"
        },
        {
          id: 1,
          label: "Participant Activities",
          name: "participantActivities",
          value: "P"
        }
      ],
      showResultsForCurrent: "All",
      showResultsForList: [],
      showActivitiesForIsHidden: true,
      showActivitiesForCurrent: "",
      showActivitiesForList: [
        {
          id: 0,
          title: "My Support Team",
          value: "ST",
          icon: iconUserFriends
        },
        {
          id: 1,
          title: "About Me",
          value: "AM",
          icon: iconUserCircle
        },
        {
          id: 2,
          title: "Community Activities",
          value: "CA",
          icon: iconHappy
        },
        {
          id: 3,
          title: "My Goals",
          value: "MG",
          icon: iconStar
        },
        {
          id: 4,
          title: "Required Services",
          value: "RS",
          icon: iconClipboardList
        }
      ]
    }
  }

  componentDidMount() {
    const {
      store: { user },
      onGetActivities,
      onGetParticipants
    } = this.props

    onGetActivities(user.token)

    onGetParticipants(user.token).then(results => {
      const showResultsForList = [
        {
          id: "all",
          title: "All",
          value: "All"
        }
      ]

      results.map(item => {
        if (item.participant) {
          showResultsForList.push({
            id: item.participant.id,
            title: `${item.participant.first_name} ${item.participant.last_name}`,
            value: item.participant.id
          })
        }

        return null
      })

      this.setState({ showResultsForList })
    })
  }

  onChangeOnly = (name, checked, value) => {
    const { showOnlyCurrent } = this.state

    let results

    if (checked) {
      results = showOnlyCurrent.concat([{ name, value }])
    } else {
      results = showOnlyCurrent.filter(item => !(item.name === name))
    }

    this.setState(
      {
        showOnlyCurrent: results
      },
      () => {
        this.getFilteredActivities()
      }
    )
  }

  onChangeActivitiesFor = (e, value) => {
    e.preventDefault()

    this.setState(
      {
        showActivitiesForCurrent: value
      },
      () => {
        this.getFilteredActivities()
      }
    )
  }

  onChangeResultsFor = (e, value) => {
    e.preventDefault()

    this.setState(
      {
        showResultsForCurrent: value
      },
      () => {
        this.getFilteredActivities()
      }
    )
  }

  getFilteredActivities = () => {
    const {
      store: { user },
      onGetActivities
    } = this.props
    const {
      showOnlyCurrent,
      showActivitiesForCurrent,
      showResultsForCurrent
    } = this.state

    const filters = {}

    if (showOnlyCurrent.length) {
      showOnlyCurrent.map(item => {
        filters[item.name] = item.value

        return null
      })
    }

    if (showActivitiesForCurrent) {
      filters.section = showActivitiesForCurrent
    }

    if (!!showResultsForCurrent && showResultsForCurrent !== "All") {
      filters.participant = showResultsForCurrent
    }

    onGetActivities(user.token, filters)
  }

  toggleSidebarFilters = name => {
    const { showOnlyIsHidden, showActivitiesForIsHidden } = this.state

    const current = {
      showOnlyIsHidden,
      showActivitiesForIsHidden
    }

    this.setState({ [name]: !current[name] })
  }

  getActivitieMessages = () => {
    const {
      store: { activities }
    } = this.props

    const activitieMessages = []

    activities.map(activitie => {
      activitieMessages.push({
        type: "activity",
        id: activitie.id,
        createdAt: activitie.created_at,
        title: activitie.content,
        subtitle:
          activitie.plan_section !== null && activitie.plan_section !== "-1"
            ? `Section: ${configs.plan_section[activitie.plan_section]}`
            : false,
        content: activitie.content,
        iconDesc: activitie.icon_desc,
        buttonText: activitie.button_text
      })

      return null
    })

    return activitieMessages
  }

  render() {
    const {
      notifications,
      store: { activitiesLoading, participants, participantsLoading }
    } = this.props
    const {
      showOnlyIsHidden,
      showOnlyList,
      showOnlyCurrent,
      showResultsForList,
      showResultsForCurrent,
      showActivitiesForIsHidden,
      showActivitiesForList,
      showActivitiesForCurrent
    } = this.state

    const activitieMessages = this.getActivitieMessages()

    return (
      <div className="main-container main-container--light activity">
        <Header theme="dark" />

        <div className="content">
          <div
            className={`content_section_header ${notifications &&
              "content_section_header--dark"}`}
          >
            <div className="container">
              <div className="row">
                <div className="col-md-10 offset-md-1">
                  <h1 className="content_section_title">Activity overview</h1>
                </div>
              </div>
            </div>

            <Notifications />
          </div>

          {participantsLoading ? (
            <Loader
              type="TailSpin"
              color="#0c4632"
              height={80}
              width={80}
              className="loader"
            />
          ) : (
            <>
              {participants.length ? (
                <div className="container">
                  <div className="row">
                    <div className="col-md-10 offset-md-1">
                      <div className="activity_filters">
                        <div className="activity_filters_title">
                          Show results for
                        </div>
                        <div className="activity_filters_list">
                          {showResultsForList.map(({ title, value, id }) => (
                            <button
                              key={`show-results-for-${id}`}
                              className={`activity_filters_list_item ${
                                showResultsForCurrent === value
                                  ? "activity_filters_list_item--active"
                                  : ""
                              }`}
                              onClick={e => {
                                this.onChangeResultsFor(e, value)
                              }}
                              type="button"
                            >
                              {title}
                            </button>
                          ))}
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-4">
                          <div className="activity_sidebar">
                            <div className="activity_sidebar_section">
                              <div className="activity_sidebar_title">
                                Show only
                              </div>
                              <button
                                onClick={() => {
                                  this.toggleSidebarFilters("showOnlyIsHidden")
                                }}
                                type="button"
                                className="activity_sidebar_title_btn"
                              >
                                Show only
                              </button>

                              <form
                                className={`form form--dark ${
                                  showOnlyIsHidden ? "form--hidden" : ""
                                }`}
                              >
                                {showOnlyList.map(
                                  ({ id, label, name, value }) => {
                                    let checked = false

                                    showOnlyCurrent.map(item => {
                                      if (item.name === name) {
                                        checked = true
                                      }

                                      return null
                                    })

                                    return (
                                      <div
                                        key={`show-only-for-${id}`}
                                        className="form_checkbox"
                                      >
                                        <input
                                          type="checkbox"
                                          id={name}
                                          name={name}
                                          value={value}
                                          checked={checked ? "checked" : ""}
                                          onChange={e =>
                                            this.onChangeOnly(
                                              name,
                                              e.target.checked,
                                              value
                                            )
                                          }
                                        />

                                        <label htmlFor={name}>
                                          <div className="form_checkbox_text">
                                            {label}
                                          </div>
                                        </label>
                                      </div>
                                    )
                                  }
                                )}
                              </form>
                            </div>

                            <div className="activity_sidebar_section">
                              <div className="activity_sidebar_title">
                                Show activities for
                              </div>
                              <button
                                onClick={() => {
                                  this.toggleSidebarFilters(
                                    "showActivitiesForIsHidden"
                                  )
                                }}
                                type="button"
                                className="activity_sidebar_title_btn"
                              >
                                Show activities for
                              </button>

                              <div
                                className={`activity_sidebar_list ${
                                  showActivitiesForIsHidden
                                    ? "activity_sidebar_list--hidden"
                                    : ""
                                }`}
                              >
                                <ul>
                                  {showActivitiesForList.map(
                                    ({ title, icon, value, id }) => (
                                      <li
                                        className="activity_sidebar_list_item"
                                        key={`show-activities-for-${id}`}
                                      >
                                        <a
                                          className={`activity_sidebar_list_link ${
                                            showActivitiesForCurrent === value
                                              ? "activity_sidebar_list_link--active"
                                              : ""
                                          }`}
                                          href="/#"
                                          onClick={e => {
                                            this.onChangeActivitiesFor(e, value)
                                          }}
                                        >
                                          <img
                                            className="activity_sidebar_list_icon"
                                            src={icon}
                                            title={title}
                                            alt={title}
                                          />
                                          {title}
                                        </a>
                                      </li>
                                    )
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-8">
                          <Messages
                            messages={activitieMessages}
                            loading={activitiesLoading}
                            messagesTitle="Recent activity"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="container">
                  <div className="row">
                    <div className="col-md-10 offset-md-1">
                      You currently heve no participants to show any activity
                      for
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        <Footer />
      </div>
    )
  }
}

Activity.defaultProps = {
  notifications: false
}

Activity.propTypes = {
  onGetActivities: propTypes.func.isRequired,
  onGetParticipants: propTypes.func.isRequired,
  notifications: propTypes.bool,
  store: propTypes.shape({
    user: propTypes.shape({
      token: propTypes.string
    }),
    activities: propTypes.arrayOf(propTypes.shape({})),
    participants: propTypes.arrayOf(propTypes.shape({})),
    activitiesLoading: propTypes.bool,
    participantsLoading: propTypes.bool
  }).isRequired
}

const mapStateToProps = ({ AuthenticationReducer, GuardiansReducer }) => ({
  store: {
    user: AuthenticationReducer.user,
    activities: GuardiansReducer.activities,
    participants: GuardiansReducer.participants,
    activitiesLoading: GuardiansReducer.activitiesLoading,
    participantsLoading: GuardiansReducer.participantsLoading
  }
})

const mapDispatchToProps = dispatch => ({
  onGetParticipants: token => dispatch(getParticipants(token)),
  onGetActivities: (token, filters) => dispatch(getActivities(token, filters))
})

export default connect(mapStateToProps, mapDispatchToProps)(Activity)
